import axios from 'axios';

// Long enough to cover a worst-case voice turn (Claude generation, then TTS
// with a fallback-provider retry on failure) without leaving the UI stuck
// forever on a truly hung request.
const DEFAULT_TIMEOUT_MS = 45000;

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: DEFAULT_TIMEOUT_MS,
});

/** No auth headers — buyer chat agent lookup, etc. */
export const publicApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: DEFAULT_TIMEOUT_MS,
});

export default api;